export default __webpack_public_path__ + "static/media/metodospago.053f21dc.png";